import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';


class ModalStore extends BaseStore {

    getActive () {
        return this.state.get('active');
    }

    getData () {
        return this.state.get('data');
    }

    close ({ type }) {
        if (!type || type === this.getActive()) {
            this.setState(this.state.delete('active'));
        }
    }

    open ({ type, data }) {
        this.setState(this.state.set('active', type).set('data', data));
    }

    getActionHandlers () {
        return {
            [ActionTypes.MODAL_OPENED]: this.open,
            [ActionTypes.MODAL_CLOSED]: this.close
        };
    }

}

const storeInstance = new ModalStore();

export default storeInstance;
